import API from "@utils/request";
import { navigate } from "@utils";

import { FILE_ROOT, pathLoac } from "@config";

let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {

} else {
    prout = 'protal_' + Language;
}


// 获取订单列表
export async function getorderList(params) {
    try {
        return await API.post("api/" + prout + "/api/goods/orderList", params);
    } catch (error) {
        return error;
    }
}

// 订单详情
export async function getorderDetail(params) {
    try {
        return await API.post("api/" + prout + "/api/goods/orderInfo", params);
    } catch (error) {
        return error;
    }
}

// 提交订单问题反馈 goods/addOrderFeedback
export async function addOrderFeedback(params) {
    console.log(params,"paramsparams")
    try {
        return await API.post("api/" + prout + "/api/goods/addOrderFeedback", params);
    } catch (error) {
        return error;
    }
}

// 确认收货
// 确认收货
export async function confirmReceive(params) {
    try {
        return await API.post("api/" + prout + "/api/goods/confirmReceive", params);
    } catch (error) {
        return error;
    }
}

// 查询物流轨迹
export async function logisticsQuery(params) {
    try {
        // 后端控制器：app\protal\controller\api\goods\LogisticsController@query
        // 路由风格与其他 goods 接口一致
        return await API.post("api/" + prout + "/api/logistics/query", params);
    } catch (error) {
        return error;
    }
}

export async function checkDelivered(params) {
    try {
        return await API.post("api/" + prout + "/api/logistics/check-delivered", params);
    } catch (error) {
        return error;
    }
}

